import Vue from "vue";
import VueRouter from "vue-router";
import checkoutStore from "../store/index.js";

Vue.use(VueRouter);

export const checkoutRoutes = [
    {
        path: "/",
        name: "login",
        component: () => import("../../components/checkout/screens/LoginScreen.vue"),
        meta: {
            label: "Login",
            step: 1,
            showCart: true
        }
    },
    {
        path: "/data",
        name: "data",
        component: () => import("../../components/checkout/screens/DataScreen.vue"),
        meta: {
            label: "Shipping",
            step: 2,
            showCart: true
        }
    },
    {
        path: "/overview",
        name: "overview",
        component: () => import("../../components/checkout/screens/OverviewScreen.vue"),
        meta: {
            label: "Overview",
            step: 3,
            showCart: true
        }
    },
    {
        path: "/thanks",
        name: "thanks",
        component: () => import("../../components/checkout/screens/EndScreen.vue"),
        meta: {
            label: "Payment",
            step: 4,
            showCart: false
        }
    },
    {
        path: "/empty-cart",
        name: "empty-cart",
        component: () => import("../../components/checkout/screens/EmptyCartScreen.vue"),
        meta: {
            showCart: false
        }
    },
    {
        path: "/reset-password",
        name: "passwordReset",
        component: () => import("../../components/account/screens/PasswordResetScreen.vue"),
        meta: {
            label: "Password reset",
            inNav: false,
            fullWidth: true
        }
    }
]

export const accountRoutes = [
    {
        path: "/",
        name: "login",
        component: () => import("../../components/account/screens/LoginScreen.vue"),
        meta: {
            label: "Login",
            inNav: false
        }
    },
    {
        path: "/profile",
        name: "profile",
        component: () => import("../../components/account/screens/ProfileScreen.vue"),
        meta: {
            label: "Profile",
            inNav: true
        }
    },
    {
        path: "/orders",
        name: "orders",
        component: () => import("../../components/account/screens/OrdersScreen.vue"),
        meta: {
            label: "Orders",
            inNav: true
        }
    },
    {
        path: "/orders/:reference",
        name: "order",
        component: () => import("../../components/account/screens/OrderScreen.vue"),
        meta: {
            label: "Order",
            inNav: false
        }
    },
    {
        path: "/addresses",
        name: "addresses",
        component: () => import("../../components/account/screens/AddressesScreen.vue"),
        meta: {
            label: "Addresses",
            inNav: true
        }
    },
    {
        path: "/reset-password",
        name: "passwordReset",
        component: () => import("../../components/account/screens/PasswordResetScreen.vue"),
        meta: {
            label: "Password reset",
            inNav: false,
            fullWidth: false
        }
    }
]

export const checkoutRouter = new VueRouter({
    routes: checkoutRoutes
});

export const accountRouter = new VueRouter({
    routes: accountRoutes
});

accountRouter.beforeEach((to, from, next) => {
    if (!checkoutStore.state.user.userLoggedIn && to.name !== 'login' && to.name !== 'passwordReset') {
        next({path: '/'});
    } else {
        next();
    }
})
